import React from "react";
import { UserAvatar } from "Components";
import { Member } from "Types";
import styles from "./memberName.module.scss";

type MemberNameProps = {
  member: Member;
};

const MemberName = ({ member }: MemberNameProps): React.JSX.Element => {
  const fullName = `${member.first_name} ${member.last_name}`;

  return (
    <div className={styles.wrapper}>
      <UserAvatar user={member} />
      <div className={styles["user-details"]}>
        <div className={styles["full-name"]}>{fullName.trim() || "--"}</div>
      </div>
    </div>
  );
};

export default MemberName;
